// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-ccb24f80] .ant-table-placeholder {\n  border-radius: 0;\n}\n.btnBox[data-v-ccb24f80] {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 10px;\n}\n[data-v-ccb24f80] .ant-table-tbody .rowClass {\n  background: #ffa39e;\n}", ""]);
// Exports
module.exports = exports;
